const root = document.documentElement;
const themeButton = document.querySelector<HTMLButtonElement>('#theme-toggle')!;
function setTheme(light: boolean): void {
  root.dataset.theme = light ? 'light' : 'dark';
  themeButton.textContent = light ? '◐' : '☼';
  themeButton.setAttribute('aria-label', light ? 'Activer le thème sombre' : 'Activer le thème clair');
  document.querySelector('meta[name="theme-color"]')?.setAttribute('content', light ? '#f4f5ee' : '#101612');
}
try { setTheme(localStorage.getItem('portfolio-theme') === 'light'); } catch { setTheme(false); }
themeButton.addEventListener('click', () => {
  setTheme(root.dataset.theme !== 'light');
  try { localStorage.setItem('portfolio-theme', root.dataset.theme!); } catch { /* Theme remains usable without storage. */ }
});

const domains: Record<string, [string, string]> = {
  software: ['01 / LOGICIEL', 'Du C/C++ aux applications web et Android : construire, comprendre et faire évoluer.'],
  ai: ['02 / IA & RECHERCHE', 'Au SnT, dans l’équipe SerVal : expérimenter sur les LLM pour le code et évaluer les tests.'],
  systems: ['03 / SYSTÈMES & RÉSEAUX', 'Linux, auto-hébergement et cybersécurité : mes applications vivent aussi sur mes propres serveurs.'],
  testing: ['04 / TESTS & V&V', 'Chez Airbus : intégrer, automatiser et analyser les tests de systèmes de communication critiques.'],
};
document.querySelectorAll<HTMLButtonElement>('[data-domain]').forEach(button => {
  button.addEventListener('click', () => {
    const domain = domains[button.dataset.domain!];
    if (!domain) return;
    document.querySelector('#domain-label')!.textContent = domain[0];
    document.querySelector('#domain-description')!.textContent = domain[1];
    document.querySelectorAll<HTMLButtonElement>('[data-domain]').forEach(node => {
      node.classList.toggle('active', node === button);
      node.setAttribute('aria-pressed', String(node === button));
    });
  });
});

document.querySelectorAll<HTMLButtonElement>('[data-filter]').forEach(button => {
  button.addEventListener('click', () => {
    let count = 0;
    document.querySelectorAll<HTMLElement>('[data-category]').forEach(card => {
      card.hidden = button.dataset.filter !== 'all' && card.dataset.category !== button.dataset.filter;
      if (!card.hidden) count++;
    });
    document.querySelectorAll<HTMLButtonElement>('[data-filter]').forEach(filter => {
      filter.classList.toggle('selected', filter === button);
      filter.setAttribute('aria-pressed', String(filter === button));
    });
    document.querySelector('#filter-status')!.textContent = `${count} projets affichés.`;
  });
});

const terminalOutput = document.querySelector<HTMLElement>('#terminal-output')!;
const terminalInput = document.querySelector<HTMLInputElement>('#terminal-input')!;
const responses: Record<string, string> = {
  help: 'Commandes disponibles :\nabout · services · deploy · research · doom · clear\nUne visite interactive, sans connexion à un serveur.',
  about: 'Charles Chenouard\nÉlève ingénieur à IMT Atlantique, en apprentissage chez Airbus Defence & Space.\nLogiciel / Systèmes / Cybersécurité / IA.',
  services: 'Dans mon infrastructure personnelle :\n→ Portfolio et applications personnelles\n→ WikiTrouve, avec un backend Node.js\n→ Nextcloud\n→ Monitoring avec Grafana / InfluxDB\n\nLinux, réseau et maintenance au quotidien.',
  deploy: 'Le trajet d’une mise à jour de ce portfolio :\n\n01  git push origin main\n02  Réception dans un dépôt Git bare sur DietPi\n03  Le hook post-receive extrait les sources\n04  Build Vite\n05  Publication du résultat derrière nginx\n\nCeci est une explication : aucun déploiement n’est lancé.',
  research: 'SnT · SerVal · Mai–août 2026\nTests de code généré par LLM, expérimentation et benchmarks.\nCoauteur de « Prompt Coverage Adequacy ».',
  doom: 'Passage secret trouvé. Prêt pour un peu de raycasting ?',
};
function command(raw: string): void {
  const value = raw.trim().toLowerCase();
  if (!value) return;
  if (value === 'clear') { terminalOutput.replaceChildren(); terminalInput.value = ''; return; }
  const prompt = document.createElement('p');
  prompt.className = 'terminal-prompt';
  prompt.textContent = `visiteur:~ $ ${raw.trim()}`;
  const response = document.createElement('p');
  response.textContent = responses[value] ?? `Commande inconnue : ${raw.trim()}\nEssayez help pour découvrir le labo.`;
  terminalOutput.append(prompt, response);
  if (value === 'doom' || value === 'research') {
    const link = document.createElement('a');
    link.href = value === 'doom' ? 'doom-shooter.html' : 'https://arxiv.org/abs/2607.02057';
    link.textContent = value === 'doom' ? 'Lancer le mini-jeu ↗' : 'Lire la prépublication ↗';
    response.append(document.createElement('br'), link);
  }
  while (terminalOutput.children.length > 40) terminalOutput.firstElementChild?.remove();
  terminalOutput.scrollTop = terminalOutput.scrollHeight;
  terminalInput.value = '';
}
document.querySelector('#terminal-form')!.addEventListener('submit', event => {
  event.preventDefault();
  command(terminalInput.value);
});
document.querySelectorAll<HTMLButtonElement>('[data-command]').forEach(button => {
  button.addEventListener('click', () => command(button.dataset.command!));
});

export {};
